import React, { useEffect, useState } from 'react'
import $ from 'jquery'
import { useNavigate } from 'react-router-dom';

export default function Email_template() {
    const navigate = useNavigate();
    const [templates, setTemplates] = useState([]);

    const [templateName, setTemplateName] = useState("");
    const [subject, setSubject] = useState("");
    const [body, setBody] = useState("");

    const [editId, setEditId] = useState(null);


    const loadTemplates = () => {
        let company_id = localStorage.getItem('mem_company_id');
        fetch("get_templates_list.php", {
            method: 'POST',
             body: new URLSearchParams({
            company_id: company_id
        })
        })
            .then(res => res.json())
            .then(data => {
                console.log(data)
                setTemplates(data);
            })

    }

    useEffect(() => {
        loadTemplates();
    }, []);


    const insertVariable = (variable) => {
        setBody(body + variable);
    }
    const saveTemplate = () => {
      let company_id = localStorage.getItem('mem_company_id');
        const data = {
            template_name: templateName,
            subject: subject,
            body: body,
            company_id: company_id
        };

        fetch("save_template.php", {
            method: "POST",
            body: JSON.stringify(data)
        })
            .then(res => res.text())
            .then(result => {
                showAlert(result);

                setTemplateName("");
                setSubject("");
                setBody("");

                loadTemplates();

            })

    }

    const updateTemplate = () => {

        const data = {
            id: editId,
            template_name: templateName,
            subject: subject,
            body: body
        };

        fetch("update_template.php", {
            method: "POST",
            body: JSON.stringify(data)
        })
            .then(res => res.text())
            .then(result => {
                showAlert(result);

                setEditId(null);
                setTemplateName("");
                setSubject("");
                setBody("");

                loadTemplates();

            })

    }
    function removeEdit() {
        setEditId(null);
        setTemplateName("");
        setSubject("");
        setBody("");
    }

    const editTemplate = (tpl) => {

        setEditId(tpl.id);

        setTemplateName(tpl.template_name);
        setSubject(tpl.subject);
        setBody(tpl.body);

    }

    const deleteTemplate = (id) => {

        if (!window.confirm("Delete this template?")) return;

        fetch("delete_template.php", {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            },
            body: "id=" + id
        })
            .then(res => res.text())
            .then(result => {
                showAlert(result);
                loadTemplates();
            })

    }


    function showAlert(msg) {
        $('#alertpop').css('display', 'block');
        $('#alert_text').text(msg);
    }

    function closeAlert() {
        $('#alertpop').css('display', 'none');
        $('#alert_text').text('');
        localStorage.setItem('communications','template');
        navigate('/redirect_communications'); 
    }


    return (
        <div>
            <h2 className="innerpage_heading">Email Templates</h2>


            {/* FORM */}

            <div className="vl_dsh_formnholder ">
                <div className='vl_dsh_one_full'>
                    <h3 className="sectionlabel halfwidth">
                        {editId ? "Edit Template" : "Create Template"}
                    </h3>
                    {editId && (
                        <button className='vl_dsh_pop_content_close' onClick={removeEdit}>+</button>
                    )}
                </div>


                <div className="formfieldcommon">

                    <label>Template Name</label>

                    <input
                        type="text"
                        value={templateName}
                        onChange={(e) => setTemplateName(e.target.value)}
                    />

                </div>


                <div className="formfieldcommon">

                    <label>Email Subject</label>

                    <input
                        type="text"
                        value={subject}
                        onChange={(e) => setSubject(e.target.value)}
                    />

                </div>
                <div className="formfieldcommon">

                    <label>Insert Variables</label>

                    <div style={{ marginBottom: "10px" }}>

                        <button className='variablebtn' type="button" onClick={() => insertVariable("{{recipient_name}}")}>Recipient Name</button>

                        <button className='variablebtn' type="button" onClick={() => insertVariable("{{event_title}}")}>Event Title</button>

                        <button className='variablebtn' type="button" onClick={() => insertVariable("{{event_date}}")}>Event Date</button>

                        <button className='variablebtn' type="button" onClick={() => insertVariable("{{event_time}}")}>Event Time</button>

                        <button className='variablebtn' type="button" onClick={() => insertVariable("{{event_location}}")}>Event Location</button>

                    </div>

                </div>

                <div className="formfieldcommon">

                    <label>Body</label>

                    <textarea
                        value={body}
                        onChange={(e) => setBody(e.target.value)}
                        rows="6"
                    />

                </div>


                <div className="vl_dsh_buttonholder">

                    {editId ?

                        <button className="greenbutton" onClick={updateTemplate}>
                            Update Template
                        </button>

                        :

                        <button className="greenbutton" onClick={saveTemplate}>
                            Save Template
                        </button>

                    }

                </div>

            </div>



            {/* TEMPLATE LIST */}

            <div className="vl_dsh_formnholder details_section">

                <h3 className="sectionlabel">Template List</h3>

                <div className='vl_dsh_one_table'>

                    <table className="template_table">

                        <thead>
                            <tr>
                                <th>Template Name</th>
                                <th>Subject</th>
                                <th className="action_col">Action</th>
                            </tr>
                        </thead>

                        <tbody>

                            {templates.map((tpl) => (

                                <tr key={tpl.id}>

                                    <td className="tpl_name">{tpl.template_name}</td>

                                    <td className="tpl_subject">{tpl.subject}</td>

                                    <td className="action_buttons">

                                        <button
                                            className="icon_btn edit_btn"
                                            onClick={() => editTemplate(tpl)}
                                        >
                                            <i className="ri-edit-2-line"></i>
                                        </button>

                                        <button
                                            className="icon_btn delete_btn"
                                            onClick={() => deleteTemplate(tpl.id)}
                                        >
                                            <i className="ri-delete-bin-3-fill"></i>
                                        </button>

                                    </td>

                                </tr>

                            ))}

                        </tbody>

                    </table>

                </div>

            </div>
            <div className='vl_dsh_popup' id="alertpop">
                <div className='alertbox'>
                    <div className='alertheader'><h3><i className='ri-alert-line'></i>Alert</h3></div>
                    <div className='contentarea'>
                        <p id="alert_text"></p>
                    </div>
                    <div className='alert_btns'>
                        <button onClick={closeAlert}>Okay</button>
                    </div>
                </div>
            </div>
        </div>
    )
}
